export const SHOP = {
  name: "Who's Next Barber Shop",
  address: "109 Plungington Road, Preston, PR1 7UE",
  phone: "07876 746744",
  phoneDial: "07876746744",
  whatsapp: "447876746744",
  rating: 4.97,
  reviewCount: 300,
  mapEmbed:
    "https://www.google.com/maps?q=109+Plungington+Road+Preston+PR1+7UE&output=embed",
  mapLink:
    "https://www.google.com/maps/search/?api=1&query=109+Plungington+Road+Preston+PR1+7UE",
};

export const WHATSAPP_LINK = `https://wa.me/${SHOP.whatsapp}?text=${encodeURIComponent(
  "Hi Who's Next, I'd like to enquire about an appointment."
)}`;
export const CALL_LINK = `tel:${SHOP.phoneDial}`;

const DAY_ORDER = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"];

// Normalise a UK phone number to international wa.me format (447...)
export function toWhatsApp(phone) {
  const digits = (phone || "").replace(/[^\d]/g, "");
  if (!digits) return "";
  if (digits.startsWith("44")) return digits;
  if (digits.startsWith("0")) return "44" + digits.slice(1);
  return digits;
}

export function waLink(phone, text) {
  const num = toWhatsApp(phone);
  return `https://wa.me/${num}?text=${encodeURIComponent(text || "")}`;
}

export function dialLink(phone) {
  return `tel:${(phone || "").replace(/\s/g, "")}`;
}

// Build a display list of opening hours from settings.working_hours
export function formatHours(workingHours) {
  if (!workingHours) return null;
  return DAY_ORDER.map((d) => {
    const h = workingHours[d] || {};
    const label = d.charAt(0).toUpperCase() + d.slice(1);
    if (h.closed) return [label, "Closed"];
    let txt = `${h.open || "09:00"} – ${h.close || "18:00"}`;
    if (h.appointment_only) txt += " · Appointment only";
    return [label, txt];
  });
}

// Sentence listing appointment-only days
export function appointmentOnlyDays(workingHours) {
  if (!workingHours) return "";
  const days = DAY_ORDER.filter((d) => !workingHours[d]?.closed && workingHours[d]?.appointment_only)
    .map((d) => d.charAt(0).toUpperCase() + d.slice(1));
  if (days.length === 0) return "";
  if (days.length === 1) return `${days[0]} is appointment-only.`;
  return `${days.slice(0, -1).join(", ")} and ${days[days.length - 1]} are appointment-only.`;
}
